import { render, staticRenderFns } from "./ServiceFees.vue?vue&type=template&id=3102fb4a&"
import script from "./ServiceFees.vue?vue&type=script&lang=js&"
export * from "./ServiceFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ServiceFees.vue"
export default component.exports